<template>
  <div class="table_select">
    <div class="opera_btns">
      <a-button
        :disabled="disabled"
        @click="toExport"
      >
        {{ $t('message["187"]') }}
      </a-button>
    </div>
    <p class="text">
      {{ selectedTip[0] }}<span class="select_num">{{ count }}/{{ total }}</span>{{ selectedTip[1] }}
    </p>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    disabled () {
      return this.count === 0
    },
    selectedTip () {
      return this.$t('message["1478"]').split('|')
    }
  },
  methods: {
    toExport () {
      this.$emit('export')
    }
  }
}
</script>

<style scoped lang="scss">
.table_select {
  margin: 0 0 24px 0;
  .text {
    display: inline-block;
    color: $gray2;
    line-height: 24px;
    margin: 0 4px;
    .select_num {
      font-weight: 600;
      margin: 0 4px;
    }
  }
  .select_all_text:hover {
    cursor: pointer;
  }
  .opera_btns {
    display: inline-block;
  }
}
</style>
